/** Normalize an item name for matching: lowercase, no punctuation, single spaces, naive singular. */
export function normalizeName(name: string): string {
  const cleaned = name
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return cleaned
    .split(' ')
    .map((w) => singular(w))
    .join(' ');
}

function singular(word: string): string {
  if (word.length <= 3) return word;
  if (word.endsWith('ies')) return word.slice(0, -3) + 'y'; // berries -> berry
  if (word.endsWith('oes')) return word.slice(0, -2); // tomatoes -> tomato
  if (/(ss|us|is)$/.test(word)) return word; // glass, hummus, ...
  if (word.endsWith('s')) return word.slice(0, -1);
  return word;
}

/** Capitalize the first letter only ("oat milk" -> "Oat milk"). */
export function sentenceCase(s: string): string {
  const t = s.trim();
  return t.charAt(0).toUpperCase() + t.slice(1);
}

let counter = 0;
/** Short unique id. crypto.randomUUID when available (browser, Deno, Node 19+). */
export function newId(prefix = ''): string {
  const g = globalThis as { crypto?: { randomUUID?: () => string } };
  if (g.crypto?.randomUUID) return prefix + g.crypto.randomUUID();
  counter += 1;
  return `${prefix}${Date.now().toString(36)}-${counter}-${Math.random().toString(36).slice(2, 8)}`;
}

export function roundMoney(n: number): number {
  return Math.round(n * 100) / 100;
}
